import React from "react";
import { SessionType } from "./Session/Types";
import { selectRemainingTime, useAppState } from "../state";
interface SessionFooterProps {
  session: SessionType;
}
export const SessionFooter = ({
  session
}: SessionFooterProps) => {
  const [state, dispatch] = useAppState()
  const remainingTime = selectRemainingTime(state)

  return (
    <div className="inline-flex items-center text-sm font-medium text-gray-500 dark:text-gray-300">
      <div>{remainingTime}</div>
      <div className="flex float-right m-1"> Estimated minutes</div>
      <div className="flex hover:underline ml-2 mr-auto divide-y divide-gray-300/50">
        <button onClick={() => {
          dispatch({ type: "SET_SESSION_ACTIVE", payload: { sessionId: session.id, active: true } })
          dispatch({ type: "SET_TASK_ACTIVE",  payload: { sessionId: session.id, taskId: session.tasks[0].id, active: true } })
        }}>Start Session</button>
      </div>
    </div>
  );
};
